/**
 * UI
 */
export const SET_CATEGORY = 'SET_CATEGORY';
export const SET_UI_FILTER = 'SET_UI_FILTER';

/**
 * APP
 */
export const SET_APP_FILTER = 'SET_APP_FILTER';

/**
 * SAGA TRIGGERS
 */
export const APPLY_UI_FILTER = 'APPLY_UI_FILTER';
export const RESET_UI_FILTER = 'RESET_UI_FILTER';
export const RESET_FILTER = 'RESET_FILTER';
